import animals from './animals.json';
import animals2 from './animals2.json';
import household from './household.json';
import adventure from './adventure.json';
import advice from './advice.json';
import questionsAndPronouns from './questionsandpronouns.json';
import restaurants from './restaurants.json';
import routines from './routines.json';
import predictions from './predictions.json';


export const VOCABULARY_M6_U1 = [
    ...animals,
    ...animals2,
    ...household,
    ...adventure,
    ...advice,
    ...questionsAndPronouns,
    ...restaurants,
    ...routines,
    ...predictions,
];